import type { Persona } from "./Persona";

/**
 * Default name assigned to a brand-new chat thread before automatic title
 * generation overwrites it.
 */
export const DEFAULT_CHAT_THREAD_NAME = "New Chat";

/**
 *  Metadata for a single chat thread.
 *
 * Example:
 *  {
 *    "id": "a94e8081-2efa-475d-9c9e-bf031d96d8b8",
 *    "name": "Model Adaptation Techniques: Distillation vs LORA",
 *    "personaId": 1
 *  }
 */
export interface ChatThread {
  /**
   * UUIDv4 ID for this chatThread.
   */
  id: string;
  /**
   * The title of this chatThread.
   */
  name: string;
  personaId: Persona["id"];
  /**
   * The timestamp of the last message in this chatThread.
   * ISO 8601 format.
   * Example: "2024-09-25T18:12:54.552Z"
   */
  timestamp: string;
}

/**
 * ChatThreads are stored in local storage as a JSON string.
 * This type represents the deserialized form of that string.
 *
 * Example:
 * {
 *   "d9f186bb-618b-4c9c-b36f-3f7a88163e53": {
 *     "id": "d9f186bb-618b-4c9c-b36f-3f7a88163e53",
 *     "name": "Model Adaptation Techniques: Distillation vs LORA",
 *     "personaId": 1
 *   },
 *  "4ab4c492-e15f-41d0-9ec0-1c90aecd96d4": {
 *   "id": "4ab4c492-e15f-41d0-9ec0-1c90aecd96d4",
 *   "name": "Bradley-Terry Model: Predicting Pairwise Comparisons",
 *   "personaId": 1
 *   }
 * }
 */
export type ChatThreads = Record<string, ChatThread | undefined>;
